import type { Places } from '~/types/places';

const PLACES_PROFILE: Places = {
  business: {
    bank: 10,
    government: 8,
    office: 15,
  },
  education: {
    childcare: 5,
    high_school: 10,
    library: 7,
    primary: 5,
    university: 10,
  },
  essentials: {
    electricity: 12,
    gas: 10,
    sewers: 8,
    waste: 12,
    water: 14,
  },
  food: {
    bakery: 15,
    coffee: 14,
    fast_food: 10,
    restaurant: 12,
  },
  health: {
    clinic: 10,
    dentist: 6,
    hospital: 8,
    pharmacy: 7,
  },
  nature: {
    beach: -10,
    forest: -5,
    lake: -5,
    mountain: -15,
    park: 12,
    river: 5,
  },
  religion: {
    church: -5,
    mosque: -5,
  },
  shops: {
    grocery: 15,
    mall: 14,
  },
  soil: {
    clay: -5,
    loam: 0,
    peat: -10,
    salt: -15,
    sand: -10,
    silt: 0,
  },
  sport: {
    gym: 14,
    pool: 10,
  },
  telecom: {
    cable_tv: 15,
    fiber_optic: 15,
    network_4g: 15,
    network_5g: 15,
    phone: 15,
  },
  transport: {
    airport: 5,
    bus: 12,
    ferry: -5,
    gas_station: 8,
    metro: 15,
    parking: 10,
    taxi: 12,
    train: 12,
    tram: 12,
  },
};

export default PLACES_PROFILE;
